export const ROUTE_PATH = '/personnel';

export const RESOURCE_NAME = 'personnelPage';
